import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchDepartments = ({ accountId }) => get(`/accounts/${accountId}/departments`);

export const addDepartment = ({ accountId, department }) => post(`/accounts/${accountId}/departments`, department);

export const updateDepartment = ({ accountId, departmentId, department }) =>
  patch(`/accounts/${accountId}/departments/${departmentId}`, department);

export const deleteDepartment = ({ accountId, departmentId }) =>
  httpDelete(`/accounts/${accountId}/departments/${departmentId}`);
